import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import SubTabTansaksiDetail from "./subTabTansaksiDetail";

class SubTabTransaksiContent extends Component {
    render() {
        const salesPersonId = this.props.data.dataTransaction?.headerTransaction?.salesPersonId?.value
        return (
            <>
                <Tabs onSelect={(index) => this.props.handleTabChange(this.props.tabList[index])}>
                    <TabList>
                        {this.props.tabList.map((tab, index) => (
                            <Tab id={`button_navigate_${tab}`} disabled={!salesPersonId}>{tab.label}</Tab>
                        ))}
                    </TabList>
                    {this.props.tabList.map((tab, index) => (
                        <TabPanel key={index}>
                            <SubTabTansaksiDetail
                                {...this.props}
                            />
                        </TabPanel>
                    ))}
                </Tabs>
            </>
        )
    }
}

export default SubTabTransaksiContent;